import { Reveal } from "@/components/Reveal";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

const fallback = {
  orders: "150+",
  location: "PCMC, Pune",
  since: "Jan 2026",
  rating: "5.0",
};

export default function Stats() {
  const { data } = useQuery({
    queryKey: ["stats"],
    queryFn: async () => (await api.get("/stats")).data,
  });
  const s = data || fallback;

  const cells = [
    { k: s.orders, l: "Orders Crafted" },
    { k: s.rating, l: "Avg. Rating" },
    { k: s.location, l: "Based In" },
    { k: s.since, l: "Since" },
  ];

  return (
    <section
      className="mx-auto max-w-[1400px] px-6 py-20 md:px-12"
      data-testid="stats"
    >
      <div className="grid grid-cols-2 gap-6 md:grid-cols-4">
        {cells.map((c, i) => (
          <Reveal
            key={c.l}
            delay={i * 0.08}
            className="border-l border-[#311B4D] pl-5"
          >
            <div className="font-serif text-4xl font-light gold-gradient-text md:text-6xl">
              {c.k}
            </div>
            <div className="mt-2 text-xs uppercase tracking-[0.2em] text-[#A894C2]">
              {c.l}
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
